const History = {
  navigate: null,
};

export default History;
